import config from '../config.js'
import apigClientFactory from 'aws-api-gateway-client';
import { loadAuth2 } from 'gapi-script';
import AWS from 'aws-sdk';
import { CognitoUserPool } from 'amazon-cognito-identity-js';
import * as jwt_decode from 'jwt-decode';
export default class AWSApiClient {

    static refreshCognitoSession(forceRefresh = false) {
        const userObj = JSON.parse(localStorage.getItem('userObj'));
        if (!userObj || userObj.federatedIdentity) {
            return Promise.resolve();
        }

        const token = localStorage.getItem('token');
        if (!forceRefresh && !AWSApiClient.isTokenExpired(token)) {
            return Promise.resolve();
        }

        if (AWSApiClient.cognitoRefreshPromise) {
            return AWSApiClient.cognitoRefreshPromise;
        }

        const userPool = new CognitoUserPool({
            UserPoolId: config.userPoolId,
            ClientId: config.clientId
        });
        const cognitoUser = userPool.getCurrentUser();

        if (!cognitoUser) {
            return Promise.resolve();
        }

        AWSApiClient.cognitoRefreshPromise = new Promise((resolve, reject) => {
            const saveSession = (err, session) => {
                if (err) {
                    reject(err);
                    return;
                }

                if (!session || !session.isValid()) {
                    reject(new Error('Cognito session is invalid'));
                    return;
                }

                localStorage.setItem('token', session.getIdToken().getJwtToken());

                AWS.config.region = config.region;
                AWS.config.credentials = new AWS.CognitoIdentityCredentials({
                    IdentityPoolId: config.identityPoolId,
                    Logins: {
                        [config.cognitoURL]: session.getIdToken().getJwtToken()
                    }
                });
                AWS.config.credentials.clearCachedId();
                AWS.config.credentials.get((credentialsError) => {
                    if (credentialsError) {
                        reject(credentialsError);
                        return;
                    }

                    localStorage.setItem('accessKeyId', AWS.config.credentials.accessKeyId);
                    localStorage.setItem('secretAccessKey', AWS.config.credentials.secretAccessKey);
                    localStorage.setItem('sessionToken', AWS.config.credentials.sessionToken);
                    resolve();
                });
            };

            const currentSession = cognitoUser.getSignInUserSession && cognitoUser.getSignInUserSession();
            const refreshToken = currentSession && currentSession.getRefreshToken();

            if (forceRefresh && refreshToken) {
                cognitoUser.refreshSession(refreshToken, saveSession);
            } else {
                cognitoUser.getSession(saveSession);
            }
        });

        AWSApiClient.cognitoRefreshPromise = AWSApiClient.cognitoRefreshPromise.then(
            (result) => {
                AWSApiClient.cognitoRefreshPromise = null;
                return result;
            },
            (err) => {
                AWSApiClient.cognitoRefreshPromise = null;
                throw err;
            }
        );

        return AWSApiClient.cognitoRefreshPromise;
    }

    static isTokenExpired(token) {
        if (!token) {
            return true;
        }

        try {
            const decodedToken = jwt_decode(token);
            return !decodedToken.exp || decodedToken.exp * 1000 <= Date.now();
        } catch (err) {
            return true;
        }
    }

    static invokeApi(params, pathTemplate, method, additionalParams, body, urlID = "") {
        // const userOb = JSON.parse(localStorage.getItem('userObj'));
        // if (userOb && userOb.federatedIdentity) {
        //     loadAuth2(config.googleClientId, config.googleClassRoomScopes).then((auth2) => {
        //         console.log("auth2" + auth2)
        //         let token = auth2.currentUser.get().getAuthResponse()
        //         refreshIdentityToken(token);
        //         // this.setState({ "gToken": token });
        //     });

        //     const refreshIdentityToken = (response) => {

        //         const token = response['id_token'];
        //         const access_token = response['access_token'];
        //         AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        //             IdentityPoolId: config.identityPoolId,
        //             Logins: {
        //                 'accounts.google.com': token
        //             }
        //         });
        //         AWS.config.region = config.region;
        //         AWS.config.credentials.clearCachedId();
        //         AWS.config.credentials.get(function (err, data) {
        //             if (err) {
        //                 console.log("Error: " + err);
        //             }
        //             localStorage.setItem('accessToken', access_token);
        //             localStorage.setItem('identityToken', token);
        //             localStorage.setItem('accessKeyId', AWS.config.credentials.accessKeyId);
        //             localStorage.setItem('secretAccessKey', AWS.config.credentials.secretAccessKey);
        //             localStorage.setItem('sessionToken', AWS.config.credentials.sessionToken);

        //         });
        //         // additionalParams["headers"]["Authorization"] = 'Bearer ' + access_token

        //         return AWS.config.credentials.getPromise();
        //     }
        // }
        const setUserName = (additionalParams) => {

            const paramsOption = 'headers';
            const userNameAttr = 'username-id';
            const langAttr = 'language';
            const userObj = JSON.parse(localStorage.getItem('userObj'));
            const accessToken = userObj && userObj.federatedIdentity ? localStorage.getItem('identityToken') : localStorage.getItem('token');


            if (!userObj)
                return additionalParams

            if (additionalParams === undefined) {
                additionalParams = {};
                additionalParams[paramsOption] = {};
                additionalParams[paramsOption][userNameAttr] = userObj.userName;
                additionalParams[paramsOption][langAttr] = userObj.prefLanguage ? userObj.multiLingualLicense ? userObj.prefLanguage : 'en' : 'en';
                additionalParams[paramsOption]["Authorization"] = 'Bearer ' + accessToken
            } else {
                if (additionalParams[paramsOption] === undefined)
                    additionalParams[paramsOption] = {};
                additionalParams[paramsOption][userNameAttr] = userObj.userName;
                additionalParams[paramsOption][langAttr] = userObj.prefLanguage ? userObj.multiLingualLicense ? userObj.prefLanguage : 'en' : 'en';
                additionalParams[paramsOption]["Authorization"] = 'Bearer ' + accessToken
            }

            if (additionalParams['accessToken']) {
                additionalParams[paramsOption]['accessToken'] = additionalParams.accessToken;
                delete additionalParams['accessToken'];
            }

            return additionalParams;
        }

        const invoke = () => {
            additionalParams = setUserName(additionalParams);

            var invokeUrl = config["invokeURL" + urlID];
            var awsConfig = {
                secretKey: localStorage.getItem('secretAccessKey'),
                sessionToken: localStorage.getItem('sessionToken'),
                region: config.region,
                apiKey: undefined,
                defaultContentType: 'application/json',
                defaultAcceptType: 'application/json',
                invokeUrl: invokeUrl
            };

            var apigClient = apigClientFactory.newClient(awsConfig);
            return apigClient.invokeApi(params, pathTemplate, method, additionalParams, body);
        };

        return AWSApiClient.refreshCognitoSession()
            .then(invoke)
            .catch((result) => {
                const response = result && result.response;
                const status = result && (result.status || result.statusCode) ||
                    (response && (response.status || response.statusCode));
                const userObj = JSON.parse(localStorage.getItem('userObj'));

                if (Number(status) !== 403 || !userObj || userObj.federatedIdentity) {
                    throw result;
                }

                return AWSApiClient.refreshCognitoSession(true).then(invoke);
            });
    }

}